import React, { useState, useEffect } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import Carousel from "../projectCarousel";
import { technologies } from "../../../data/technologies";

const Project = ({ project }) => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);

  function renderTechnologies(extraClass = "") {
    return (
      <div className={`project-detail-technologies-container ${extraClass}`.trim()}>
        {project.techs.map((techKey, index) => {
          const tech = technologies.find((item) => item.key === techKey);

          return tech ? (
            <img
              key={`${project.slug}-${techKey}-${index}-${extraClass || "default"}`}
              src={`/assets/technologies/${tech.icon}`}
              alt={tech.name}
              title={tech.name}
            />
          ) : null;
        })}
      </div>
    );
  }

  useEffect(() => {
    if (project.assetImages?.length) {
      const loaded = project.assetImages.map((file) => `${project.assetFolder}${file}`);

      setImages(loaded);
    } else {
      setImages([]);
    }
  }, [project]);

  return (
    <div className="project-details-container">
      <div className="project-details-container-wrapper">
        <div className="project-description-container">
          <p className="project-name">{t(project.titleKey)}</p>
          {renderTechnologies("project-detail-technologies-mobile")}
          <div className="project-description-wrapper">
            {t(project.descriptionKey)
              .split("\n")
              .map((paragraph, index) => (
                <p className="project-description" key={index}>
                  {paragraph}
                </p>
              ))}
          </div>
        </div>
        <div className="project-media-container">
          <div className="project-carousel-container">
            <Carousel images={images} />
          </div>
          {renderTechnologies("project-detail-technologies-desktop")}
        </div>
      </div>
    </div>
  );
};

export default Project;
